import { IDataProvinceResourceShortProps } from '../../../props/data/geographics/provinces';
import Request from './../../request';

// import props

const DataProvinceService = {
    retrieve: async (qs?: string): Promise<IDataProvinceResourceShortProps[]> => {
        try {
            const results = await Request.get(`/api/data/geographics/provinces?${qs || ""}`);
            return results;
        } catch (e) {
            throw (e);
        }
    }
};

export default DataProvinceService;